<template>
  <div class="qcc" :class="{'active':qccList.length > 0}">
    <div class="qcc--header">
      <div class="qcc--header--title">
<!--        <div class="title&#45;&#45;back iconfont"><span>&#xe600;</span></div>-->
        <div class="title--text">企查查信息</div>
<!--        <div class="title&#45;&#45;add iconfont"></div>-->
      </div>
    </div>
    <div class="header-line"></div>
    <div class="qcc--content" v-if="qccList.length>0">
      <div
        class="qcc--content--item"
        v-for="item in qccList"
        :key="item._id"
      >
        <div class="item-desc">企业名称:<span>{{item.corpName}}</span></div>
        <div class="item-desc">变动日期:<span>{{item.changeDate}}</span></div>
        <div class="item-txt">
          <div>
            分类名称:<span>{{item.typeName}}</span>
          </div>
          <div>
            风险级别:<span>{{item.categoryName}}</span>
          </div>
        </div>
        <div class="item-content">
          <div class="content-title">变更内容:</div>
          <div class="content-text">{{item.changeContent}}</div>
        </div>
      </div>
    </div>
    <div class="qcc--content" v-else>
      <van-empty description="暂无数据" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { get } from '../api/api'
export default {
  name: 'Qcc',
  data () {
    return {
      keyWord: '', // 公司名称
      pageNum: 1, // 获取营销事项列表从那一条开始
      pageSize: 10, // 获取营销事项列表一共多少条
      qccList: [], // 营销信息列表
      qccTotal: '', // 营销信息列表总数
      scrollNum: 50, // 滑动到底部提前控制触发的数值
      scrollQccFlag: true // 控制滑动pageNum在没有返回值的时候不能加1
    }
  },
  beforeMount () {
    this.keyWord = this.$route.query.keyWord
    this.getQccList()
  },
  mounted () {
    window.addEventListener('scroll', this.handleToQccListScroll, true)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleToQccListScroll, true)
  },
  methods: {
    async getQccList () {
      const result = await get('/api/INFOCENTER-APP/qcc/queryRaderList', {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        keyWord: this.keyWord
      })
      if (result.success) {
        this.scrollQccFlag = true
        this.qccTotal = result.data.total
        this.qccList = this.qccList.concat(result.data.list)
      }
    },
    async handleToQccListScroll (e) {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight + this.scrollNum >= scrollHeight) {
        if (this.qccList.length < this.qccTotal && this.scrollQccFlag) {
          this.pageNum = this.pageNum + 1
          this.scrollQccFlag = false
          this.getQccList()
        } else if (this.qccList.length === this.qccTotal) {
          this.scrollNum = 0
          this.$toast.success('数据已全部加载')
        }
      }
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.qcc
  position : relative
  width : 100vw
  height : 100vh
  overflow-x : hidden
  overflow-y : scroll
  &.active
    padding-bottom : 64px
  .qcc--header
    position : fixed
    top:0
    left:0
    width : 100%
    z-index : 10
    .qcc--header--title
      box-sizing : border-box
      width : 100%
      height : 85px
      display : flex
      line-height : 85px
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--back
        flex : 1
        text-align : left
        span
          font-size : 42px
          padding : 0 16px
      .title--text
        flex : 1
        text-align : center
      .title--add
        flex : 1
        text-align : right
        span
          font-size : 42px
          padding : 0 16px
  .header-line
    height : 85px
    width : 100%
  .qcc--content
    .qcc--content--item
      margin : 16px 16px 0 16px
      border : 2px solid #f7f7f7
      background-color : #faf9f9
      border-radius : 12px
      .item-desc
        border-bottom : 1px solid #687591
        padding : 8px 0 8px 32px
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        span
         padding-left : 24px
         &.desc__span
           padding-left : 50px
      .item-txt
        display : flex
        padding : 8px 0 8px 32px
        border-bottom : 1px solid #687591
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        div
          flex : 1
          span
            padding-left : 24px
      .item-content
        display : flex
        padding : 8px 0 8px 32px
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .content-title
          width : 138px
        .content-text
          padding-left : 25px
          flex : 1
</style>
